<template>
  <div>
    <div v-if="(ticketIndex + 1) % 4 == 1" class="tearOffWrapper" />
    <div class="ticket">
      <pdf-ticket-left
        :print-design="printDesign"
        :fiscalisation-info="fiscalisationInfo"
        :event-info="eventInfo"
        :buyer="buyer"
        :seller-name="sellerName"
        :is-custom-fiscalisation="isCustomFiscalisation"
        :ticket-seller-organization="ticketSellerOrganization"
        :ticket-name="ticketName"
        :ticket-price="ticketPrice"
        :order-payment-type="orderPaymentType"
        :ticket-location="ticketLocation"
        :order-number="orderNumber"
        :purchased-at="purchasedAt"
        :hide-price="hidePrice"
        :organization="organization"
        :qrcode="qrcode"
        :tickets-info="ticketsInfo"
        :ticket-index="ticketIndex"
      />
      <pdf-ticket-right
        :print-design="printDesign"
        :hide-price="hidePrice"
        :ticket-name="ticketName"
        :qrcode="qrcode"
        :barcode="barcode"
        :event-info="eventInfo"
        :show-ticket-owner="showTicketOwner"
        :ticket-owner-name="ticketOwnerName"
      />
    </div>
    <div
      v-if="(ticketIndex + 1) % 4 == 0"
      class="tearOffWrapper"
      style="page-break-after: always"
    />
  </div>
</template>

<script>
import pdfTicketLeft from './pdf-ticket-left.vue'
import pdfTicketRight from './pdf-ticket-right.vue'

export default {
  name: 'pdf-ticket',
  components: {
    pdfTicketLeft,
    pdfTicketRight,
  },
  props: [
    'fiscalisationInfo',
    'qrcode',
    'ticketLocation',
    'buyer',
    'barcode',
    'isCustomFiscalisation',
    'ticketSellerOrganization',
    'eventInfo',
    'ticketName',
    'sellerName',
    'ticketPrice',
    'orderPaymentType',
    'purchasedAt',
    'orderNumber',
    'organization',
    'printDesign',
    'hidePrice',
    'ticketIndex',
    'ticketsInfo',
    'showTicketOwner',
    'ticketOwnerName',
  ],
}
</script>

<style scoped>
.ticket {
  display: flex;
  flex-direction: row;
  height: 70mm;
  width: 210mm;
}

.tearOffWrapper {
  height: 26px;
  width: 210mm;
  display: flex;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  font-size: 8px;
  line-height: 9px;
  color: #000;
}

.tearOff {
  margin-left: 90mm;
  margin-top: 10px;
}
</style>
